const initialState = {
  isLoading: false,
  totalRegistros: 0,
  veiculo: [],
  open: false,
  id: 0,
  ano: '',
  placa: '',
  renavam: '',
  numeroChassis: '',
  hodometro: '',
  idOrgao: 0,
  idSubOrgao: 0,
  idMarca: 0,
  idTipoVeiculo: 0,
  idTipoCombustivel: 0,
  modelo: '',
  orgao: [],
  marca: [],
  subOrgao: [],
  caminhoFoto: '',
  telemetria: false,
  gestaoAbastecimento: false,
  usuariosVeiculos: [],
  veiculoOcorrencias: [],
  totalRegistrosOcorrencias: 0,
  excluido: false,
}

export function veiculo(state = initialState, action) {
  switch (action.type) {
    case 'FETCHED_ALL_VEICULO':
      return {
        ...state,
        veiculo: action.veiculo,
        totalRegistros: action.totalRegistros
      }
    case 'FETCHED_ALL_VEICULO_OCORRENCIAS':
      return {
        ...state,
        veiculoOcorrencias: action.veiculoOcorrencias,
        totalRegistrosOcorrencias: action.totalRegistrosOcorrencias
      }
    case 'VEICULO_DETAIL':
      return {
        ...state,
        isLoading: false,
        id: action.id,
        ano: action.ano,
        placa: action.placa,
        renavam: action.renavam,
        hodometro: action.hodometro,
        numeroChassis: action.numeroChassis,
        idOrgao: action.idOrgao,
        idSubOrgao: action.idSubOrgao,
        idTipoVeiculo: action.idTipoVeiculo,
        idTipoCombustivel: action.idTipoCombustivel,
        idMarca: action.idMarca,
        modelo: action.modelo,
        marca: action.marca,
        orgao: action.orgao,
        subOrgao: action.subOrgao,
        caminhoFoto: action.caminhoFoto,
        telemetria: action.telemetria,
        gestaoAbastecimento: action.gestaoAbastecimento,
        usuariosVeiculos: action.usuariosVeiculos,
        excluido: action.excluido
      }
    case 'VEICULO_UPDATED':
      return state   
    case 'VEICULO_CLEAR':
      return initialState
    case 'VEICULO_CLEAR_ALL':
      return {
        ...state,
        veiculo: []
      }
    case 'VEICULO_CLEAR_USUARIOS_VEICULOS':
      return {
        ...state,
        usuariosVeiculos: []
      }
    case 'VEICULO_HANDLE_ON_CHANGE':
      return {
        ...state,
        [action.props]: action.value
      }
    case 'VEICULO_ISLOADING':
      return {
        ...state,
        isLoading: true
      }
    case 'VEICULO_NOTISLOADING':
      return {
        ...state,
        isLoading: false
      }
    default:
      return state
  }
}
